export const headers_home = {
    'es': [
        {
            'title' : "<strong>Oficina</strong> de<br/><strong>Educación Online</strong>",
            'url'   : "/images/header_1.jpg",
            'align' : "caption-left"
        },
        {
            'title' : "<strong>Plataforma</strong> de <strong>gestión</strong><br/>del <strong>aprendizaje</strong> de la<br/><strong>Universidad</strong> de <strong>Chile</strong>",
            'url'   : "/images/header_2.jpg",
            'align' : "caption-left"
        },
        {
            'title' : "<strong>Evolucionamos</strong><br/>de <strong>acuerdo</strong> a las<br/><strong>necesidades</strong><br/><strong>pedagógicas</strong>",
            'url'   : "/images/header_3.jpg",
            'align' : "caption-left"
        },
    ]
}


export const headers_platform = {
    'es': [
        {
            'title' : "<strong>Plataforma</strong>",
            'url'   : "/images/header_2.jpg",
            'align' : "caption-center"
        }
    ]
}

export const headers_teaching_assistance= {
    'es': [
        {
            'title' : "<strong>Apoyo Docente</strong>",
            'url'   : "/images/header_2.jpg",
            'align' : "caption-center"
        }
    ]
}

export const headers_we = {
    'es': [
        {
            'title' : "<strong>Nosotros</strong>",
            'url'   : "/images/header_3.jpg",
            'align' : "caption-center"
        }
    ]
}

export const headers_projects = {
    'es': [
        {
            'title' : "<strong>Proyectos</strong>",
            'url'   : "/images/header_2.jpg",
            'align' : "caption-center"
        }
    ]
}

export const headers_teachings = {
    'es': [
        {
            'title' : "<strong>Formación Docente</strong>",
            'url'   : "/images/header_2.jpg",
            'align' : "caption-center"
        }
    ]
}
